import { Component } from '@theme/component';

class VibeTemperatureRange extends Component {
  #bands = [];

  connectedCallback() {
    super.connectedCallback();

    const dataScript = this.querySelector('script[data-vibe-temp-bands]');
    if (!dataScript) return;

    try {
      this.#bands = JSON.parse(dataScript.textContent).sort((a, b) => a.temp - b.temp);
    } catch {
      return;
    }
    if (this.#bands.length === 0) return;

    const input = this.querySelector('[data-vibe-temp-input]');
    const ticks = this.querySelector('[data-vibe-temp-ticks]');
    if (!input) return;

    input.min = '0';
    input.max = String(this.#bands.length - 1);
    input.step = '1';

    const defaultIndex = this.#bands.findIndex((band) => band.temp >= -5);
    input.value = String(defaultIndex >= 0 ? defaultIndex : Math.floor(this.#bands.length / 2));

    if (ticks) {
      ticks.textContent = '';
      for (const band of this.#bands) {
        const tick = document.createElement('span');
        tick.textContent = this.#formatTemp(band.temp);
        ticks.append(tick);
      }
    }

    input.addEventListener('input', () => this.#render(Number(input.value)));
    this.#render(Number(input.value));
  }

  #formatTemp(temp) {
    return temp > 0 ? `+${temp}` : temp < 0 ? `−${Math.abs(temp)}` : '0';
  }

  #render(index) {
    const band = this.#bands[index];
    if (!band) return;

    const set = (selector, value) => {
      const el = this.querySelector(selector);
      if (el) el.textContent = value ?? '';
    };

    set('[data-vibe-temp-value]', this.#formatTemp(band.temp));
    set('[data-vibe-temp-condition]', band.condition);
    set('[data-vibe-temp-underneath]', band.underneath);
    set('[data-vibe-temp-activities]', band.activities);
    set('[data-vibe-temp-prevents]', band.prevents);
  }
}

if (!customElements.get('vibe-temperature-range')) {
  customElements.define('vibe-temperature-range', VibeTemperatureRange);
}
